import angular = require("angular");
import TPL = require("templates");

export class PriceBadgeDirective {

  template = TPL.contentDirectives.priceBadge;
  scope = {
    params: "=params"
  };

  static factory() {
    return () => new PriceBadgeDirective();
  }

}



/** WEBPACK FOOTER **
 ** ./src/scripts/directives/content/priceBadge.ts
 **/